const LOCATIONS = {
  uae: {
    label: "/UAE",
    home: "/ae-en/web-design-dubai/",
    serviceBase: "/ae-en/",
    slugSuffix: "-dubai",
  },
  ksa: {
    label: "/KSA",
    home: "/sa-en/web-design-riyadh/",
    serviceBase: "/sa-en/",
    slugSuffix: "-riyadh",
  },
  uk: {
    label: "/UK",
    home: "/uk-en/web-design-london/",
    serviceBase: "/uk-en/",
    slugSuffix: "-london",
  },
  "": {
    label: "/ Global",
    home: "/",
    serviceBase: "/services/",
    slugSuffix: "",
  },
};

const STORAGE_KEY = "dg_location";

const LOCATION_PREFIXES = [
  "/ae-en/web-design-dubai",
  "/sa-en/web-design-riyadh",
  "/uk-en/web-design-london",
  "/ae-en",
  "/sa-en",
  "/uk-en",
].sort((a, b) => b.length - a.length);

const GLOBAL_SECTIONS =
  /^\/(blog|about-us|contact-us|case-studies|industry|privacy-policy|terms-and-condition|thank-you|thankyou|404)(\/|$)/i;

function LocationSwitcher() {
  const trigger = document.querySelector(".locationSwitcher__trigger");
  const modal = document.getElementById("locationModal");
  const backdrop = document.getElementById("locationModalBackdrop");
  const label = document.getElementById("locationSwitcherLabel");

  if (!trigger || !modal || !backdrop) return;

  const closeBtn = modal.querySelector(".locationModal__close");
  const btns = modal.querySelectorAll(".locationModal__btn");

  const saved = localStorage.getItem(STORAGE_KEY) || "";
  const validSaved = Object.prototype.hasOwnProperty.call(LOCATIONS, saved)
    ? saved
    : "";
  markActive(validSaved);

  trigger.addEventListener("click", () => toggleModal(true));
  if (closeBtn) closeBtn.addEventListener("click", () => toggleModal(false));
  backdrop.addEventListener("click", () => toggleModal(false));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") toggleModal(false);
  });

  btns.forEach((btn) => {
    btn.addEventListener("click", () => selectLocation(btn.dataset.location || ""));
  });

  function toggleModal(open) {
    if (open) {
      const rect = trigger.getBoundingClientRect();
      modal.style.top = rect.bottom + 8 + "px";
      modal.style.left = rect.left + "px";
    }
    modal.classList.toggle("is-open", open);
    backdrop.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", String(open));
  }

  function selectLocation(loc) {
    const data = LOCATIONS[loc] || LOCATIONS[""];
    if (label) label.textContent = data.label;
    localStorage.setItem(STORAGE_KEY, loc);
    document.cookie = `dg_location=${loc};path=/;max-age=31536000`;
    markActive(loc);
    toggleModal(false);
    window.location.href = buildUrl(loc);
  }

  function stripAllLocationPrefixes(path) {
    let stripped = path || "/";
    let changed = true;

    while (changed) {
      changed = false;
      for (const prefix of LOCATION_PREFIXES) {
        const re = new RegExp("^" + escapeRegExp(prefix) + "(?=/|$)", "i");
        if (re.test(stripped)) {
          stripped = stripped.replace(re, "") || "/";
          changed = true;
          break;
        }
      }
    }

    // Drop accidental /services/ left after a location prefix
    stripped = stripped.replace(/^\/services(?=\/|$)/i, "") || "/";
    if (!stripped.startsWith("/")) stripped = "/" + stripped;
    return stripped.replace(/\/{2,}/g, "/");
  }

  function remapServiceSlug(slug, loc) {
    const clean = String(slug || "")
      .replace(/-(dubai|riyadh|london)$/i, "")
      .replace(/^\/+|\/+$/g, "");
    if (!clean) return "";
    const suffix = (LOCATIONS[loc] || LOCATIONS[""]).slugSuffix || "";
    return clean + suffix;
  }

  function buildUrl(loc) {
    const data = LOCATIONS[loc] || LOCATIONS[""];
    // Always go to location home page on switch
    return data.home;
  }

  function markActive(loc) {
    btns.forEach((btn) => {
      btn.classList.toggle("active", (btn.dataset.location || "") === loc);
    });
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
}

export default LocationSwitcher;
